import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../assets/images/about/Poste-AuxLettres.png'
import _imports_1 from '../../assets/images/about/Colis-Postaux.png'
import _imports_2 from '../../assets/images/about/Transport-de-Cois-et-Marchandises.png'


const _hoisted_1 = { class: "about-wrap style1 pt-20 pb-20" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row gx-5" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "content-title style1" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h3", null, "Nos valeurs", -1)
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1)
const _hoisted_9 = { class: "row gx-5" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_1 })
  ])
], -1)
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = {
  class: "content-title style1",
  id: "vision"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Notre vision", -1)
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = { class: "row gx-5" }
const _hoisted_16 = { class: "col-lg-6" }
const _hoisted_17 = {
  class: "content-title style1",
  id: "mission"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h3", null, "Notre mission est:", -1)
const _hoisted_19 = ["innerHTML"]
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-6" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_2 })
  ])
], -1)
const _hoisted_21 = { class: "row gx-5" }
const _hoisted_22 = { class: "col-lg-12" }
const _hoisted_23 = {
  class: "content-title style1",
  id: "mission"
}
const _hoisted_24 = /*#__PURE__*/_createElementVNode("h3", null, "Historique de L' École d’Initiation Théologique et Pastorale", -1)
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-lg-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "mb-20" }, [
    /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
  ])
], -1)
const _hoisted_27 = { class: "row gx-5" }
const _hoisted_28 = { class: "col-lg-12" }
const _hoisted_29 = {
  class: "content-title style1",
  id: "organigramme"
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("h2", null, "Notre organigramme :", -1)
const _hoisted_31 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Aproposs, (apropos) => {
        return (_openBlock(), _createElementBlock("div", {
          key: apropos.id
        }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                ref_for: true,
                ref: "blockvaleur",
                class: _normalizeClass(["about-content section", { visible: _ctx.valeur }])
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("p", {
                    class: "",
                    innerHTML: apropos.valeur
                  }, null, 8, _hoisted_7)
                ])
              ], 2)
            ]),
            _hoisted_8
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                ref_for: true,
                ref: "blockmission",
                class: _normalizeClass(["about-content section mb-20", { visible: _ctx.mission }])
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createElementVNode("p", {
                    class: "mb-20",
                    innerHTML: apropos.vision
                  }, null, 8, _hoisted_14)
                ])
              ], 2)
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", {
                ref_for: true,
                ref: "blockmission",
                class: _normalizeClass(["about-content section mb-20", { visible: _ctx.mission }])
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("p", {
                    class: "",
                    innerHTML: apropos.mission
                  }, null, 8, _hoisted_19)
                ])
              ], 2)
            ]),
            _hoisted_20
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", {
                ref_for: true,
                ref: "blockmission",
                class: _normalizeClass(["about-content section mb-20", { visible: _ctx.mission }])
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _createElementVNode("p", {
                    innerHTML: apropos.historique
                  }, null, 8, _hoisted_25)
                ])
              ], 2)
            ]),
            _hoisted_26
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", {
                ref_for: true,
                ref: "blockorganigramme",
                class: _normalizeClass(["about-content section", { visible: _ctx.organigramme }])
              }, [
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("p", {
                    innerHTML: apropos.organigramme
                  }, null, 8, _hoisted_31)
                ])
              ], 2)
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}